import { useState } from 'react'
import { Typography, Divider, CircularProgress, LinearProgress } from "@mui/material"
import { useSelector, useDispatch, Triggers, useTrigger, Actions } from "../../stores/dashboard.store"
import { useSnackbar } from "../snackbar/snackbar"
import { getProjectSettings, deleteProject, saveProjectSettings } from "../../api-client/data"
import Button from '../nura/button/button'
import useFetch from "../../hooks/useFetch"
import styles from './styles.module.css'
import DeleteProject from "../dialogs/delete-project"

export default function Settings() {
    const { activeProject } = useSelector()
    const trigger = useTrigger(Triggers.RefreshProjectList)
    const dispatch = useDispatch()
    const projectSettings = useFetch(() => getProjectSettings(activeProject?.id))
    const [showDeleteProjectModal, setShowDeleteProjectModal] = useState(false)
    const { enqueueSnackbar} = useSnackbar()
    const [saving, setSaving] = useState(false)

    const saveSettings = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        if (!formData.get('title')|| formData.get('title') === "") {
            enqueueSnackbar("Title is required", { variant: "error" })
            return
        }

        setSaving(true)
        await saveProjectSettings({
            ID: activeProject?.id,
            Name: formData.get('title'),
            Description: formData.get('description'),
        })
        setSaving(false)

        enqueueSnackbar("Settings saved", { variant: "success" })
        trigger()
    }

    const localDeleteProject = async () => {        
        await deleteProject(activeProject?.id)
        dispatch(Actions.ResetState)
        window.location.reload()
        
        trigger()
        
        enqueueSnackbar("Project Deleted", { variant: "success" })        
    }

    return (
        <>
            <DeleteProject handleDelete={localDeleteProject} show={showDeleteProjectModal} setShow={setShowDeleteProjectModal} />
            <div className={styles.dashboardHeader}>
                <div className={styles.dashboardTitle}>
                    <Typography variant="h6">Settings</Typography>
                </div>
            </div>
            {
                projectSettings.loading && <LinearProgress />
            }
            {
                !projectSettings.loading && (
                    <div className={styles.settingsDetails}>
                        <div className={styles.settingsGeneral}>
                            <Typography variant="h6" className={styles.actionTitle}>General</Typography>
                            <Divider />
                        </div>
                        <div className={styles.settingsInnerContainer} >
                            <form style={{ margin: "5px" }} onSubmit={saveSettings}>
                                <div className={styles.actionTitle}>Name</div>
                                <input
                                    className={styles.settingsTextField}
                                    name="title"
                                    defaultValue={projectSettings?.data?.name}
                                />

                                <div style={{ marginTop: 15 }} className={styles.actionTitle}>Description</div>
                                <textarea
                                    className={styles.settingsTextArea}
                                    name="description"
                                    defaultValue={projectSettings?.data?.description}
                                />

                                <div style={{ marginTop: 5 }}>
                                    <Button disabled={saving} style={{ width: 80 }} type="submit" size="normal" variant="fancy">{saving ? <CircularProgress size={13} /> : <>Save</> }</Button>
                                </div>
                            </form>

                            <div className={styles.settingsRedZone}>
                                <Typography variant="h6" className={styles.actionTitle}>Red Zone</Typography>
                                <Divider />
                            </div>

                            <div className={styles.dangerZone}>
                                <div style={{ flex: 1 }}>
                                    <div className={styles.actionTitle}>Delete this project</div>
                                    <div className={styles.actionDescription}>Delete this project permanently</div>
                                </div>
                                <Button size="normal" variant="error" onClick={() => setShowDeleteProjectModal(true)}>Delete</Button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}
